{
  "$comment": [
    "The BFF's copy of the effective-prod feature-flag manifest — the nine of the",
    "sixteen keys this process serves. Captured live from the prod PostHog project",
    "and confirmed key by key by the app owner (#145 capture comment, 2026-08-24);",
    "never derived from the old stack's code fallbacks, two of which contradict prod",
    "on purpose. Python carries its own copy of the ten keys it serves",
    "(server/app/core/feature_flags.json); the three keys both processes read are",
    "drift-pinned from each side. 9 + 10 - 3 = 16.",
    "",
    "This file is values only. Which keys exist, and whether a key is read as a",
    "boolean, as a payload, or as both, is declared once in feature-flags.ts and",
    "checked against this file at import — so a key added here without a home there",
    "(or the reverse) fails loudly instead of resolving to a silent default.",
    "",
    "A `payload` key carries no `value`: none was captured, because nothing reads one.",
    "Payloads are stored PARSED (object / number / array / string), never in the",
    "stringified form PostHog holds them in. Changing a value here is a deploy: the",
    "interim drift procedure for a moved prod value is an edit to this file."
  ],
  "flags": {
    "enable_maintenance": {
      "value": false,
      "note": "Absent from the prod project entirely — this value is the old code default, recorded as such, not a capture. Enabled shape is `\"value\": true` plus `\"payload\": {\"back_at\": \"2026-09-01T18:00:00Z\"}`; the reader supports `back_at` today so the takeover (#153) can be wired and tested. The one flag decided server-side, before any app HTML."
    },
    "enable_notifications": {
      "value": true,
      "note": "Dual-read with Python — drift-pinned by feature-flags-drift.unit.test.ts and its Python counterpart. Confirmed true for both readers."
    },
    "enable_admin_tab": {
      "value": true,
      "note": "Half the Admin gate only; the admin capability still applies independently (#152)."
    },
    "enable_simulate_user": {
      "value": false,
      "note": "active: true at rollout 0, so it evaluates false. No Atlas consumer — X-Simulate-User impersonation was ruled out in #67. Carried for parity."
    },
    "enable_target_cost_upload": {
      "value": true,
      "note": "Dual-read with Python since #1212 — drift-pinned by feature-flags-drift.unit.test.ts and its Python counterpart. Gates the Item Catalog's upload card here and Python's presign and start (#552 D1). Flipped to true on both sides by #1213, with the card, following prod (on since 2026-10-28)."
    },
    "push_to_community_specs": {
      "value": true,
      "note": "Prod is at rollout 100 while the old code default was false — the manifest follows prod, which is the whole point of capturing live. The 2026-08-05 modsy audit row recording 'no users' is stale: updated_at is 2026-08-04 and last_called_at is 2026-08-22."
    },
    "enable_community_map": {
      "value": true
    },
    "content_user_permissions": {
      "payload": [],
      "note": "Dual-read with Python — drift-pinned. Ships EMPTY by owner call (2026-08-24) to keep PII out of checked-in code: prod holds two live per-user email/groups/division overrides which are deliberately not carried into Atlas. Re-homing them is out of scope; this is not a gap."
    },
    "content_create_visualization_dialog_splash_image_url": {
      "payload": "https://lennar.modsyhub.com/digitalops/landing-page/home-plan-spotlight-august-2025-v3.webp",
      "note": "Verbatim from prod. The host is modsy infra, sunsetting January 2027, and the gating key enable_create_visualization sits at rollout 0 in prod — so this payload is dead there today."
    }
  }
}
